import React from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import CoinsVideo from "../../../Utils/Assets/Images/coins-rotating.webm";
const EarnStakeMVR = () => {
    return (
        <div className={styles.container}>
            <MeetUsWrapper>
                <div className={styles.cardBorderWrapper}>
                    <div className={styles.cardBorder}>
                        <div className={styles.cardFlex}>
                            {/* Text */}
                            <div
                                className={styles.flexCol}
                                data-aos="fade-right"
                                data-aos-duration="800"
                                data-aos-once="false"
                            >
                                <div className={styles.subtext}>
                                    <div className={styles.titleWrapper}>
                                     
                                        <p>
                                            Start Earning & Staking MVR <br />{" "}
                                            Influence Coins Today!
                                        </p>
                                        <div className={styles.buttonRight}>
                                            <button></button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <video
                                    src={CoinsVideo}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className={styles.coinsVideo}
                                    data-aos="fade-up"
                                    data-aos-duration="800"
                                ></video>
                            </div>
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default EarnStakeMVR;
